import { render, staticRenderFns } from "./TinyCart.vue?vue&type=template&id=710a9387&"
import script from "./TinyCart.vue?vue&type=script&lang=js&"
export * from "./TinyCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports